// Note: This file is used for the web app only.
// Changes to this file might also need to be applied
// to `ServicesProvider.native.ts` if they are relevant for the native app as well.

import { getEnvVar } from '@egr/xbox/utils/ReactScriptHelper';

import { ServiceProvider } from '@easterngraphics/pcon-services';

export const pConServiceProvider = new ServiceProvider(getEnvVar('X_PCON_SERVICES', 'default'));